import { createFileRoute } from "@tanstack/react-router";
import { redirect } from "@/lib/navigation";

function RouteComponent() {
  redirect("/support");
}

export const Route = createFileRoute("/_authenticated/emails/")({
  component: RouteComponent,
});
